import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  num: '1',
  title: 'Descargas el protocolo',
  desc: "Y localizas los '3 ladrones de estrógeno' en tu cocina actual."
}, {
  num: '2',
  title: 'Aplicas la Ventana de Quema Oro',
  desc: 'Ajustas QUÉ comes según el momento del día.'
}, {
  num: '3',
  title: 'Observas los cambios',
  desc: 'Cómo tu energía regresa y tu ropa empieza a quedar holgada en la primera semana.'
}];
export function HowItWorks() {
  return <section className="py-20 px-6 md:px-12 bg-white" data-id="element-91">
      <div className="max-w-4xl mx-auto" data-id="element-92">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-93">
          <h2 className="text-3xl md:text-4xl font-bold text-charcoal mb-4" data-id="element-94">
            ¿Cómo funciona?
          </h2>
          <p className="text-lg text-gray-600" data-id="element-95">
            Un proceso simple de 3 pasos diseñado para tu estilo de vida
            ocupado.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-96">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-1/2 left-0 w-full h-0.5 bg-sage/20 -z-10 -translate-y-1/2" data-id="element-97"></div>

          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="bg-cream p-8 rounded-3xl text-center relative z-10 shadow-sm border border-sage/10" data-id="element-98">
              <div className="w-16 h-16 bg-sage text-white rounded-full flex items-center justify-center text-2xl font-bold mx-auto mb-6 shadow-lg" data-id="element-99">
                {step.num}
              </div>
              <h3 className="text-xl font-bold text-charcoal mb-3" data-id="element-100">
                {step.title}
              </h3>
              <p className="text-gray-600" data-id="element-101">{step.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}